import React from "react";
import "./AddUser.css";

interface TextInputProps {
  label: string;
  name: string;
  formik: any;
  type?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  maxLength?: number;
   onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  formik,
  type = "text",
  placeholder,
  required,
  disabled,
  helperText,
  fullWidth,
  onChange,
  maxLength
}) => {
  const error = formik.touched[name] && formik.errors[name];

  return (
    <div>
      <label className="addUser-label">
        {label} {required && <span className="addUser-required">*</span>}
      </label>

      {helperText && <div className="addUser-helper-text">{helperText}</div>}

      <input
        maxLength={maxLength}
        name={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        value={formik.values[name]}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          } else {
            formik.handleChange(e);
            formik.validateField(name);
          }
        }}
        onBlur={formik.handleBlur}
        className={`addUser-input${fullWidth ? " addUser-input--full" : ""}`}
      />

      <div className="addUser-error">{error ?? ""}</div>
    </div>
  );
};
